import { StackProps } from "@mui/material"
import { Stack } from ".."
import ThreeDotsLoader from "../three-dots-loader"

const PageLoader = ({
  isLoading,
  height,
  position,
  color,
  backgroundColor,
  ...rest
}: {
  isLoading: boolean
  position?: "absolute" | "fixed"
  height?: string
  backgroundColor?: string
  color?: string
} & StackProps) => {
  if (!isLoading) return <></>
  return (
    <Stack
      variant="rowCenter"
      sx={{ background: backgroundColor ?? "rgba(0,0,0,0.25)" }}
      position={position ? position : "fixed"}
      zIndex={9}
      top={0}
      left={0}
      height={height ? height : "100vh"}
      width={"100%"}
      {...rest}
    >
      <ThreeDotsLoader backgroundColor={color} />
    </Stack>
  )
}

export default PageLoader
